import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const config = {
    apiKey: "AIzaSyDp3ayCO0M17BJ1JyHaxrMDDNrcOIA2MHA",
    authDomain: "shoppers-point-09.firebaseapp.com",
    projectId: "shoppers-point-09",
    storageBucket: "shoppers-point-09.appspot.com",
    messagingSenderId: "695878869419",
    appId: "1:695878869419:web:3306649f11c452c459b2ee",
    measurementId: "G-RL4646WSCP" 
  };



export const createUserProfileDocument = async (userAuth, additionalData) => {
    if (!userAuth) return;

    const  userRef = firestore.doc(`users/${userAuth.uid}`);

    const snapShot = await userRef.get();
    


   if(!snapShot.exists) {  
       const { displayName , email } = userAuth;
       const createAt = new Date();


       try {
         await userRef.set({
           displayName,
           email,
           createAt,
           ...additionalData
         })

       }catch(error) {
        console.log('error creating user', error.message);
       }
   }
    
   return userRef;

};


  firebase.initializeApp(config);
  

  export const auth = firebase.auth();
  export const firestore = firebase.firestore();

  const provider = new firebase.auth.GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' });
  export const signInWithGoogle = () => auth.signInWithPopup(provider);

  export default firebase;